module.exports = __webpack_public_path__ + "img/green-green-fon.c4c3faf2.png";